var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.619,
    height: 17.771,
    viewBox: "0 0 23.619 17.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2655",
    "data-name": "Group 2655",
    transform: "translate(2169.141 -11770)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M116.838,102.018a.4.4,0,0,0-.57,0l-1.882,1.882V87.911a.4.4,0,0,0-.808,0V103.9l-1.882-1.882a.4.4,0,0,0-.57.57l2.569,2.569h0a.4.4,0,0,0,.569,0l2.569-2.569a.4.4,0,0,0,0-.57Z",
    transform: "translate(-2280.171 11682.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M262.662,87.5H268.8c.089,0,.162.223.162.4v2.423c0,.223-.072.4-.162.4h-6.139c-.089,0-.162-.223-.162-.4V87.9C262.5,87.681,262.572,87.5,262.662,87.5Z",
    transform: "translate(-2424.649 11682.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M262.78,192.5h8.393c.155,0,.28.223.28.4v2.423c0,.223-.125.4-.28.4H262.78c-.154,0-.28-.223-.28-.4V192.9C262.5,192.681,262.625,192.5,262.78,192.5Z",
    transform: "translate(-2424.649 11582.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M263.064,297.5h12.409c.311,0,.564.223.564.4v2.423c0,.223-.253.4-.564.4H263.064c-.311,0-.564-.223-.564-.4V297.9C262.5,297.681,262.753,297.5,263.064,297.5Z",
    transform: "translate(-2424.649 11482.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M263.539,402.5h14.549c.574,0,1.039.223,1.039.4v2.423c0,.223-.465.4-1.039.4H263.539c-.574,0-1.039-.223-1.039-.4V402.9C262.5,402.681,262.965,402.5,263.539,402.5Z",
    transform: "translate(-2424.649 11382.04)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortLine);
export default __webpack_public_path__ + "static/media/sort_line.128972d8c06b332a4f349f85f4233c15.svg";
export { ForwardRef as ReactComponent };